import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshFeatureFlags } from '../../auth/state/authSlice';

/**
 * FeatureFlagInitializer Component
 * Ensures feature flags are extracted from token on app load
 * This handles cases where Redux state is persisted but feature flags weren't extracted yet
 */
const FeatureFlagInitializer = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const featureFlags = useSelector((state) => state.auth.featureFlags);
  
  useEffect(() => {
    // If we have a token but no feature flags, extract them
    if (token && !featureFlags) {
      dispatch(refreshFeatureFlags());
    }
  }, [token, featureFlags, dispatch]);
  
  // This is a utility component, doesn't render anything
  return null;
};

export default FeatureFlagInitializer;

